
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getAddChatMembersDtoFormGroup() {
return new FormGroup({
    userIds: new FormControl<Array<number> | undefined>([], [Validators.required]),
})
;
}
      